<template>
  <el-dialog
    title="审批轨迹"
    :visible.sync="innerVisible"
    width="520px"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-timeline v-if="timeline.length">
      <el-timeline-item
        v-for="item in timeline"
        :key="item.taskId || item.stepNo"
        :type="item.timelineType || undefined"
        :color="item.timelineType ? undefined : '#E4E7ED'"
        :timestamp="formatWorkflowTrailTime(item.actionDate || item.createDate)"
      >
        {{ item.stepName || ('步骤' + item.stepNo) }} — {{ item.assigneeUserName || '' }}
        <span v-if="item.statusLabel">（{{ item.statusLabel }}）</span>
        <div v-if="item.comment" style="color:#909399;font-size:12px;">{{ item.comment }}</div>
      </el-timeline-item>
    </el-timeline>
    <el-empty v-else description="暂无审批记录" :image-size="80" />
    <span slot="footer">
      <el-button type="primary" @click="innerVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { buildWorkflowTimeline, formatWorkflowTrailTime, resolveWorkflowTrailTasks } from '../utils/workflow'

export default {
  name: 'WorkflowTrailDialog',
  props: {
    visible: { type: Boolean, default: false },
    tasks: { type: Array, default: () => [] },
    workflowInstance: { type: Object, default: null }
  },
  computed: {
    innerVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    },
    timeline() {
      return buildWorkflowTimeline(resolveWorkflowTrailTasks(this.workflowInstance, this.tasks))
    }
  },
  methods: {
    formatWorkflowTrailTime
  }
}
</script>
